import { Flex, Text } from '@chakra-ui/react';

export function LabelValue({ label, value }: { label: string; value: any }) {
  return (
    <Flex align="center" justify="space-between">
      <Text variant="meta-field">{label}</Text>
      <Text variant="small">{value}</Text>
    </Flex>
  );
}
